import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react';
import cm from 'classnames';
import { Drawer } from 'ksnm-common-ui/lib/Drawer';

import { Row } from '@common/Row';
import { fetchReferences } from '@stores/dictionaryStores/fetchReferences';
import { organizationsStore } from '@stores/dictionaryStores/organizationsStore';
import { periodsStore } from '@stores/dictionaryStores/periodsStore';
import { reportGroupsStore } from '@stores/dictionaryStores/reportGroupsStore/reportGroupsStore';

import styles from './InfoDrawer.module.scss';

export const InfoDrawer = observer(({ selectEntity, setSelectEntity }) => {
  const { organizations } = organizationsStore;
  const { reportGroups } = reportGroupsStore;
  const { periods } = periodsStore;

  const {
    reportPackageCodeCm,
    organization,
    reportGroupCode,
    reportPackageYear,
    periodCode,
    reportPackageCorrection,
    ctrlVersCode,
    ctrlExt,
    ctrlVersDesc,
    ctrlGroupCode,
    ctrlGroupName,
    execCtrlQty,
    execNum,
  } = selectEntity || {};

  useEffect(() => {
    fetchReferences(['periods', 'reportGroups', 'organizations']);
  }, []);

  const onClose = useCallback(() => {
    setSelectEntity(null);
  }, [setSelectEntity]);

  const org = organizations.find((item) => item.code === organization);
  const reportGroup = reportGroups?.find((item) => item.code === reportGroupCode);
  const period = periods.find((item) => item.code === periodCode)?.name;

  return (
    <Drawer open={!!selectEntity} onClose={onClose} resizable title="Дополнительные параметры" zIndex={1015}>
      <>
        <Row name="Код пакета" value={reportPackageCodeCm} className={styles.row} />
        <Row name="Код организации" value={org ? `${org.code} - ${org.name}` : ''} className={styles.row} />
        <Row
          name="Группа отчетности"
          value={reportGroup ? `${reportGroup.code} - ${reportGroup.name}` : ''}
          className={styles.row}
        />
        <Row name="Год" value={reportPackageYear} className={styles.row} />
        <Row name="Период" value={`${periodCode} - ${period}`} className={styles.row} />
        <Row name="Номер корректировки" value={reportPackageCorrection} className={styles.row} />

        {ctrlGroupCode && (
          <Row
            name="Группа контролей"
            value={`${ctrlGroupCode} - ${ctrlGroupName}`}
            className={cm(styles.row, styles.topMargin)}
          />
        )}
        {ctrlVersCode && <Row name="Контроль" value={`${ctrlVersCode} - ${ctrlExt}`} className={styles.row} />}
        {ctrlVersDesc && <Row name="Описание контроля" value={ctrlVersDesc} className={styles.row} />}
        <Row name="Количество запусков КП" value={`${ctrlVersDesc ? execNum : execCtrlQty}`} className={styles.row} />
      </>
    </Drawer>
  );
});
